import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import Feedback from "../../models/feedback.model";
import { FeedbackService } from "../../services/feedback.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";

@Component({
  selector: "ngx-dialog-feedback",
  templateUrl: "dialog-feedback.component.html",
  styleUrls: ["dialog-feedback.component.scss"],
})
export class DialogFeedbackComponent implements OnInit {
  @Input() header: string;
  @Input() mode: string;
  @Input() feedback: Feedback = new Feedback();

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imagesUrl = [];

  constructor(
    protected ref: NbDialogRef<DialogFeedbackComponent>,
    private fb: FormBuilder,
    private feedbackService: FeedbackService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    const descriptionValidators = [
      Validators.minLength(3),
      Validators.maxLength(500),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      description: ["", descriptionValidators],
      sourceType: [Validators.required],
      privacy: [Validators.required],
      content: [],
      url: [],
    });

    if (this.feedback.tags && this.feedback.tags.length > 0) {
      var trees = new Set([]);
      this.feedback.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("Góp Ý");
    }

    if (!this.feedback.sourceType) {
      this.feedback.sourceType = "document";
    }
    if (!this.feedback.status) {
      this.status = "1";
    } else {
      this.status = this.feedback.status.toString();
    }
    if (this.feedback.imagesUrl && this.feedback.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.feedback.imagesUrl);
    }
    if (!this.feedback.content) {
      this.feedback.content = "";
    }
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.feedback);
    } else {
      this.ref.close();
    }
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.feedback.tags = tags;
    this.feedback.status = parseInt(this.status);

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    this.feedbackService
      .create(this.feedback)
      .then((data) => {
        this.feedback = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.feedback);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;

    this.feedbackService
      .update(this.feedback)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.showToast("success", "Cập nhật bài viết", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật bài viết", "thất bại");
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.feedback.imagesUrl) {
      this.feedback.imagesUrl = [];
    }
    this.feedback.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.feedback.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value.trim().toUpperCase());
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
